import { useEffect } from 'react';

//A component that takes a graphql useLazyQuery hook and a query and returns a component
// that can be used to fetch data from the server and display a loading spinner while the data is being fetched
// is also displays an error component if there is an error
//the graphql hook returns {data, loading, error, called, refetch}

const LazyFetchComponentInner = ({ query, hook, variables, children }) => {
  const [executeQuery, { data, loading, error, called, refetch }] = hook(query, {
    variables,
    fetchPolicy: 'network-only',
    onError: (error) => { console.error(JSON.stringify(error)) },
    onCompleted: (data) => {
      if (data) {
        // responseErrorHandler(data)
        let res = data[Object.keys(data)[0]]
        children({ data: res, loading, error, called });
      }
    }
  });

  // Call the query immediately on component mount
  useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  if (loading) return 'Loading...';
  if (error) return `Error! ${error.message}`;
  if (!loading && !!data) {
    return (
      <>
        {children({ data, loading, error, called, refetch })}
      </>
    )
  }
  return <div>{loading ? "loading" : "not loading"}, {error ? JSON.stringify(error) : 'no error'} {data ? JSON.stringify(data) : 'no data'} {called ? 'called' : 'not called'}</div>
}

const LazyFetchComponent = ({ hookKey, ...props }) => {
  const hookRunnerKey = hookKey || props.hook?.name || "lazy-fetch-component";

  return <LazyFetchComponentInner key={hookRunnerKey} {...props} />;
};

export default LazyFetchComponent;
